import './ComponentView.scss';

export { default } from './ComponentView';
